import { Component, Input } from '@angular/core';
import { TranslationService } from '@proximus/ng-common';

@Component({
  selector: 'mprd-home-gateway',
  templateUrl: './home-gateway.component.html',
})
export class HomeGatewayComponent {
  @Input() accessNumber: string;
  redirectUrl: string;

  constructor(private translationService: TranslationService) {}

  goToHomeGatewaySite() {
    localStorage.setItem('circuitId', this.accessNumber);
    window.location.href = this.translationService.getTranslatedValueFor(
      'internet.settings.home.gateway.link',
    );
  }
}
